import { render } from "./Roulette.vue?vue&type=template&id=8f90fa0a&scoped=true"
import script from "./Roulette.vue?vue&type=script&lang=js"
export * from "./Roulette.vue?vue&type=script&lang=js"

import "./Roulette.vue?vue&type=style&index=0&id=8f90fa0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f90fa0a"]])

export default __exports__